import React, { CSSProperties, MouseEvent, useRef } from 'react';
import DotsIcon from '../../../../../../ui/svg/common/dots-icon';
import { INotification } from '../../../notifications-interfaces';
import { IStoreProps } from '../../../index';
import { useDispatch } from 'react-redux';

interface IDotsMenuProps {
    storeProps: IStoreProps;
    notification: INotification;
}

export const WIDTH = 175;

const DotsMenu = ({ storeProps, notification }: IDotsMenuProps) => {

    const { useAppSelector, rootActions } = storeProps;

    const additionalOpenedMenuNotification = useAppSelector(store => store.root.additionalOpenedMenuNotification);

    const dispatch = useDispatch();

    const buttonRef = useRef<HTMLButtonElement>(null);

    const isOpened = notification.userNTFGUID === additionalOpenedMenuNotification?.userNTFGUID;

    const toggle = () => {

        const $box = document.querySelector('.top-notifications-drop');
        if(!$box) return;

        const containerRect = $box.getBoundingClientRect();

        let styles: CSSProperties|null = null;

        if(buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            styles = {
                position: 'absolute',
                top: rect.bottom - containerRect.top,
                left: rect.right - WIDTH -containerRect.left,
                width: `${ WIDTH }px`,
                zIndex: 1000
            };
        }

        if(notification.userNTFGUID === additionalOpenedMenuNotification?.userNTFGUID) {
            dispatch(
                rootActions.main({
                    additionalOpenedMenuStyles: null,
                    additionalOpenedMenuNotification: null,
                })
            );
            return;
        }

        dispatch(
            rootActions.main({
                additionalOpenedMenuStyles: styles,
                additionalOpenedMenuNotification: notification,
            })
        );
    };

    const menuId = `notification-menu-${ notification.userNTFGUID }`;

    const stopPropagation = (evt: MouseEvent) => {
        evt.stopPropagation();
    };

    return (
        <div className="relative ml-auto" onClick={ stopPropagation }>

            <button
                ref={ buttonRef }
                onClick={ toggle }
                type="button"
                aria-label="Open notification actions"
                aria-expanded={ isOpened }
                aria-controls={ menuId }
                style={{
                    width: '20px',
                }}>
                <DotsIcon width={ '20px' } height={ '20px' } color={ '#6B6258' } />
            </button>
        </div>
    )
};

export default DotsMenu;